import {gql} from "@apollo/client";
import {SELECT_OPTION_FIELDS } from "graphql/types/SelectOptionType";

export const LIST_HUB_SORT_CODE_SELECT_OPTIONS = gql`
    query WarehouseQuery {
        allOptions: getAllHubSortCodeOptions {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;
